const paths = {
  list: '/safeDriver/list'
};

export default paths;
